import {
  MODYFY_SUBCAMPAIGN, MODIFY_SUBCAMPAIGN_FEEDBACK, SET_SUBCAMPAIGN_NOTES, MODIFY_SUBCAMPAIGN_ORIGINAL_VALUES,
  MODIFY_SUBCAMPAIGN_DESCRIPTION_NOTES, MODIFY_SUBCAMPAIGN_CLASSIFICATION_NOTES, MODIFY_SUBCAMPAIGN_HARDWARE_NOTES,
  MODIFY_SUBCAMPAIGN_SOFTWARE_NOTES, MODIFY_SUBCAMPAIGN_INFO, MODIFY_SUBCAMPAIGN_VEHICLES_NOTES, SET_SUBCAMPAIGN_SUMMARY,
  SET_SUBCAMPAIGN_PLANTFEEDBACK, SET_SUBCAMPAING_NOTES_BY_TAB, SET_VALIDATIONS_SUBCR, SET_FEEDBACK_VALIDATIONS,
  RESET_SUBCAMPAIGN,
} from '../types';

export const resetSubCampaign = () => ({
  type: RESET_SUBCAMPAIGN,
  payload: null,
});

export const setSubCampaign = (subCampaign) => ({
  type: MODYFY_SUBCAMPAIGN,
  payload: subCampaign,
});

export const setSubCampaignOriginalValues = (subCampaign) => ({
  type: MODIFY_SUBCAMPAIGN_ORIGINAL_VALUES,
  payload: subCampaign,
});

export const setSubCampaignComments = (comments) => ({
  type: SET_SUBCAMPAIGN_NOTES,
  payload: comments,
});

export const setSubCampaignNotesByTab = (payload) => ({
  type: SET_SUBCAMPAING_NOTES_BY_TAB,
  payload,
});

export const setSubCampaignSummary = (summary) => ({
  type: SET_SUBCAMPAIGN_SUMMARY,
  payload: summary,
});

export const setSubCampaignFeedback = (feedback) => ({
  type: MODIFY_SUBCAMPAIGN_FEEDBACK,
  payload: feedback,
});

export const setSubCampaignDescriptionNotes = (descriptionNotes) => ({
  type: MODIFY_SUBCAMPAIGN_DESCRIPTION_NOTES,
  payload: descriptionNotes,
});

export const setSubCampaignClassificationNotes = (classificationNotes) => ({
  type: MODIFY_SUBCAMPAIGN_CLASSIFICATION_NOTES,
  payload: classificationNotes,
});

export const setSubCampaignHardwareNotes = (hardwareNotes) => ({
  type: MODIFY_SUBCAMPAIGN_HARDWARE_NOTES,
  payload: hardwareNotes,
});

export const setSubCampaignSoftwareNotes = (softwareNotes) => ({
  type: MODIFY_SUBCAMPAIGN_SOFTWARE_NOTES,
  payload: softwareNotes,
});

export const setSubCampaignVehiclesNotes = (softwareNotes) => ({
  type: MODIFY_SUBCAMPAIGN_VEHICLES_NOTES,
  payload: softwareNotes,
});

export const setSubCampaignInfo = (subCampaignInfo) => ({
  type: MODIFY_SUBCAMPAIGN_INFO,
  payload: subCampaignInfo,
});

export const setSubCampaignPlantFeedback = (plantFeedback) => ({
  type: SET_SUBCAMPAIGN_PLANTFEEDBACK,
  payload: plantFeedback,
});

export const setValidations = (validations) => ({
  type: SET_VALIDATIONS_SUBCR,
  payload: validations,
});

export const setFeedbackValidations = (validations) => ({
  type: SET_FEEDBACK_VALIDATIONS,
  payload: validations,
});
